module.exports = __webpack_public_path__ + "static/img/cont216.5ff192a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont216.jpg
// module id = FlWw
// module chunks = 0